import React from "react";

export default function Footer() {
  return (
    <footer>
      Coded by{" "}
      <a
        href="https://www.linkedin.com/in/mildred-arizpe-vicencio/"
        target="_blank"
        rel="noopener noreferrer"
      >
        {" "}
      </a>
      <strong>Mildred Arizpe</strong>, with a little help of {""}
      <a
        href="https://www.shecodes.io/"
        target="blank"
        rel="noopener noreferrer"
      >
        She Codes. <br></br>
      </a>{" "}
      Open-sourced
      <a
        href="https://github.com/MArizpe83/weather-app"
        target="_blank"
        rel="noopener noreferrer"
      >
        on GitHub
      </a>{" "}
      and hosted{" "}
      <a
        href="https://gleaming-platypus-74f226.netlify.app/"
        target="_blank"
        rel="noopener noreferrer"
      >
        on Netlify
      </a>
    </footer>
  );
}
